import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";

const DataTable = ({ title, newButtonRoute, data, onUpdate }) => {

  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

  const [search, setSearch] = useState("");
  const [entries, setEntries] = useState("8");
  const [selectedGestor, setSelectedGestor] = useState(null);
  const [showViewModal, setShowViewModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false); // Modal de exclusão
  const [editGestor, setEditGestor] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);

  const handleSearchChange = (e) => {
    setSearch(e.target.value);
    setCurrentPage(1);
  };
  const handleEntriesChange = (e) => {
    setEntries(e.target.value);
    setCurrentPage(1);
  };

  function formatPhone(phone) {
  if (!phone) return "";
  // Remove tudo que não for dígito
  const cleaned = phone.replace(/\D/g, "");
  if (cleaned.length <= 2) return cleaned;
  if (cleaned.length <= 7)
    return `(${cleaned.slice(0, 2)}) ${cleaned.slice(2)}`;
  return `(${cleaned.slice(0, 2)}) ${cleaned.slice(2, 7)}-${cleaned.slice(7, 11)}`;
}

  const truncateText = (text, maxLength) => {
    if (!text) return "";
    return text.length > maxLength ? text.slice(0, maxLength) + "...": text;
  };

  const filteredData = data.filter((item) => {
    const searchTerm = search.toLowerCase();
    return (
      (item.nome_gestor && item.nome_gestor.toLowerCase().includes(searchTerm)) ||
      (item.matricula_gestor && item.matricula_gestor.toLowerCase().includes(searchTerm)) ||
      (item.cargo_gestor && item.cargo_gestor.toLowerCase().includes(searchTerm)) ||
      (item.telefone_gestor && item.telefone_gestor.toLowerCase().includes(searchTerm)) ||
      (item.email_gestor && item.email_gestor.toLowerCase().includes(searchTerm))
    );
  });

  // Paginação
  const numericEntries = entries === "" ? 1 : Number(entries);
  const totalRecords = filteredData.length;
  const totalPages = Math.ceil(totalRecords / numericEntries);
  const startIndex = (currentPage - 1) * numericEntries;
  const paginatedData = filteredData.slice(startIndex, startIndex + numericEntries);

  // Renderização da paginação
  const renderPagination = () => {
    let pages = [];
    if (totalPages <= 7) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      pages.push(1);
      let start = Math.max(currentPage - 1, 2);
      let end = Math.min(currentPage + 1, totalPages - 1);
      if (currentPage <= 3) {
        start = 2;
        end = 4;
      }
      if (currentPage >= totalPages - 2) {
        start = totalPages - 3;
        end = totalPages - 1;
      }
      if (start > 2) {
        pages.push("ellipsis");
      }
      for (let i = start; i <= end; i++) {
        pages.push(i);
      }
      if (end < totalPages - 1) {
        pages.push("ellipsis");
      }
      pages.push(totalPages);
    }
    return pages.map((page, index) => {
      if (page === "ellipsis") {
        return (
          <li key={index} className="page-item disabled">
            <span className="page-link">...</span>
          </li>
        );
      } else {
        return (
          <li key={index} className={`page-item ${page === currentPage ? "active" : ""}`}>
            <button className="page-link" onClick={() => setCurrentPage(page)}>
              {page}
            </button>
          </li>
        );
      }
    });
  };

  const handleView = (gestor) => {
    setSelectedGestor(gestor);
    setShowViewModal(true);
  };

  const handleEdit = (gestor) => {
    setEditGestor({ ...gestor });
    setShowEditModal(true);
  };

  const handleDelete = (gestor) => {
    setSelectedGestor(gestor);
    setShowDeleteModal(true); // Exibe o modal de exclusão
  };

  const confirmDelete = async () => {
    try {
      const response = await fetch(`${API_BASE_URL}gestor/${selectedGestor.id}/`, {
        method: "DELETE",
      });

      if (response.ok) {
        console.log("Gestor excluído com sucesso!");
        setShowDeleteModal(false); // Fecha o modal após exclusão
        if (typeof onUpdate === "function") {
          onUpdate(); // Atualiza os dados
        }
      } else {
        console.error("Erro ao excluir o registro.");
      }
    } catch (error) {
      console.error("Erro na requisição:", error);
    }
  };

  const handleCloseView = () => setShowViewModal(false);
  const handleCloseEdit = () => setShowEditModal(false);
  const handleCloseDelete = () => setShowDeleteModal(false);

  const handleEditChange = (e) => {
    const { name, value } = e.target;
    setEditGestor({
      ...editGestor,
      [name]: value,
    });
  };

  const handleEditSubmit = async () => {
    try {
      const response = await fetch(`${API_BASE_URL}gestor/${editGestor.id}/`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(editGestor),
      });

      if (response.ok) {
        console.log("Gestor atualizado com sucesso!");
        setShowEditModal(false);
        if (typeof onUpdate === "function") {
          onUpdate(); // Atualiza os dados
        }
      } else {
        console.error("Erro ao atualizar o registro.");
      }
    } catch (error) {
      console.error("Erro na requisição:", error);
    }
  };

  return (
    <div className="card">
      <div className="card-header d-flex justify-content-between align-items-center">
        <h3 className="card-title">{title}</h3>
        <div className="btn-list">
          <NavLink to={newButtonRoute} className="btn btn-primary d-flex align-items-center">
            <span className="ms-1">Novo</span>
          </NavLink>
        </div>
      </div>

      <div className="card-body border-bottom py-3">
        <div className="d-flex">
          <div className="text-secondary">
            Mostrar
            <div className="mx-2 d-inline-block">
              <input
                type="text"
                className="form-control form-control-sm"
                value={entries}
                onChange={handleEntriesChange}
                size="3"
                aria-label="Invoices count"
              />
            </div>
            registros
          </div>
          <div className="ms-auto text-secondary">
            Procurar:
            <div className="ms-2 d-inline-block">
              <input
                type="text"
                className="form-control form-control-sm"
                value={search}
                onChange={handleSearchChange}
                aria-label="Procurar"
              />
            </div>
          </div>
        </div>
      </div>

      <div className="table-responsive">
        <table className="table card-table table-vcenter text-nowrap datatable">
          <thead>
            <tr>
              <th className="w-1">
                <input
                  className="form-check-input m-0 align-middle"
                  type="checkbox"
                  aria-label="Selecionar todos os registros"
                />
              </th>
              <th className="w-1">Matricula</th>
              <th>Nome</th>
              <th>Cargo</th>
              <th>Telefone</th>
              <th>Email</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {filteredData.length > 0 ? (
              paginatedData.map((item) => (
                <tr key={item.id}>
                  <td>
                    <input
                      className="form-check-input m-0 align-middle"
                      type="checkbox"
                      aria-label="Select invoice"
                    />
                  </td>
                  <td><span className="text-secondary">{item.matricula_gestor}</span></td>
                  <td>{truncateText(item.nome_gestor, 20)}</td>
                  <td>{truncateText(item.cargo_gestor, 18)}</td>
                  <td>{formatPhone(item.telefone_gestor)}</td>
                  <td>{truncateText(item.email_gestor)}</td>
                  <td className="text-end">
                    <span className="dropdown">
                      <button className="btn dropdown-toggle align-text-top" data-bs-toggle="dropdown">Ações</button>
                      <div className="dropdown-menu dropdown-menu-end">
                        <button className="dropdown-item" onClick={() => handleView(item)}>Ver</button>
                        <button className="dropdown-item" onClick={() => handleEdit(item)}>Editar</button>
                        <button className="dropdown-item text-red" onClick={() => handleDelete(item)}>Excluir</button>
                      </div>
                    </span>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="7" className="text-center text-muted">
                  Não existem gestores cadastrados
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      <div className="card-footer d-flex align-items-center justify-content-between">
        <p className="m-0 text-secondary">
          Exibindo{" "}
          <span>{totalRecords === 0 ? 0 : (currentPage - 1) * numericEntries + 1}</span> até{" "}
          <span>{Math.min(currentPage * numericEntries, totalRecords)}</span> de{" "}
          <span>{totalRecords}</span> registros
        </p>
        <ul className="pagination m-0">
          <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
            <button
              className="page-link"
              onClick={() => currentPage > 1 && setCurrentPage(currentPage - 1)}
              disabled={currentPage === 1}
            >
              ante
            </button>
          </li>
          {renderPagination()}
          <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
            <button
              className="page-link"
              onClick={() => currentPage < totalPages && setCurrentPage(currentPage + 1)}
              disabled={currentPage === totalPages}
            >
              prox
            </button>
          </li>
        </ul>
      </div>

      {/* Modal de visualização */}
      <Modal show={showViewModal} onHide={handleCloseView}>
        <Modal.Header closeButton>
          <Modal.Title>Detalhes do Gestor</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedGestor ? (
            <div>
              <p><strong>Nome:</strong> {selectedGestor.nome_gestor}</p>
              <p><strong>Cargo:</strong> {selectedGestor.cargo_gestor}</p>
              <p><strong>Matrícula:</strong> {selectedGestor.matricula_gestor}</p>
              <p><strong>Telefone:</strong> {formatPhone(selectedGestor.telefone_gestor)}</p>
              <p><strong>Email:</strong> {selectedGestor.email_gestor}</p>
              <hr></hr>
              <p><strong>Portaria:</strong> {selectedGestor.portaria_gestor}</p>
              <p><strong>Edição:</strong> {selectedGestor.edicao_gestor}</p>
              <p><strong>Página:</strong> {selectedGestor.pagina_gestor}</p>

            </div>
          ) : (
            <p>Carregando...</p>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseView}>Fechar</Button>
        </Modal.Footer>
      </Modal>

      {/* Modal de exclusão */}
      <Modal show={showDeleteModal} onHide={handleCloseDelete}>
        <Modal.Header closeButton>
          <Modal.Title>Confirmar Exclusão</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Tem certeza de que deseja excluir o gestor <strong>{selectedGestor?.nome_gestor}</strong>?
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseDelete}>Cancelar</Button>
          <Button variant="danger" onClick={confirmDelete}>Excluir</Button>
        </Modal.Footer>
      </Modal>

      {/* Modal para edição */}
      <Modal show={showEditModal} onHide={handleCloseEdit}>
        <Modal.Header closeButton>
          <Modal.Title>Editar Gestor</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {editGestor ? (
            <form>
              <div className="mb-3">
                <label className="form-label">Nome</label>
                <input
                  type="text"
                  className="form-control"
                  name="nome_gestor"
                  value={editGestor.nome_gestor}
                  onChange={handleEditChange}
                />
              </div>
              <div className="mb-3">
                <label className="form-label">Cargo</label>
                <input
                  type="text"
                  className="form-control"
                  name="cargo_gestor"
                  value={editGestor.cargo_gestor}
                  onChange={handleEditChange}
                />
              </div>
              <div className="mb-3">
                <label className="form-label">Matrícula</label>
                <input
                  type="text"
                  className="form-control"
                  name="matricula_gestor"
                  value={editGestor.matricula_gestor}
                  onChange={handleEditChange}
                />
              </div>
              <div className="mb-3">
                <label className="form-label">Telefone</label>
                <input
                  type="text"
                  className="form-control"
                  name="telefone_gestor"
                  value={formatPhone(editGestor.telefone_gestor)}
                  onChange={(e) => {
                    // Deixa sempre salvo só os números (para evitar bugs de repetição)
                    setEditGestor({
                      ...editGestor,
                      telefone_gestor: e.target.value.replace(/\D/g, ""),
                    });
                  }}
                  maxLength={15}
                />
              </div>
              <div className="mb-3">
                <label className="form-label">Email</label>
                <input
                  type="email"
                  className="form-control"
                  name="email_gestor"
                  value={editGestor.email_gestor}
                  onChange={handleEditChange}
                />
              </div>
              <hr></hr>
              <div className="mb-3">
                <label className="form-label">Portaria</label>
                <input
                  type="text"
                  className="form-control"
                  name="portaria_gestor"
                  value={editGestor.portaria_gestor}
                  onChange={handleEditChange}
                />
              </div>
              <div className="mb-3">
                <label className="form-label">Edição</label>
                <input
                  type="text"
                  className="form-control"
                  name="edicao_gestor"
                  value={editGestor.edicao_gestor}
                  onChange={handleEditChange}
                />
              </div>
              <div className="mb-3">
                <label className="form-label">Página</label>
                <input
                  type="text"
                  className="form-control"
                  name="pagina_gestor"
                  value={editGestor.pagina_gestor}
                  onChange={handleEditChange}
                />
              </div>
            </form>
          ) : (
            <p>Carregando...</p>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseEdit}>Cancelar</Button>
          <Button variant="primary" onClick={handleEditSubmit}>Salvar</Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default DataTable;